module.exports = {"140602001":"北城街道","140602002":"南城街道","140602003":"神头街道","140602004":"北旺庄街道","140602100":"神头镇","140602101":"利民镇","140602200":"下团堡乡","140602201":"小平易乡","140602202":"滋润乡","140602203":"福善庄乡","140602204":"南榆林乡","140602205":"贾庄乡","140602206":"沙塄河乡","140602207":"窑子头乡","140602208":"张蔡庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140602.json
// module id = 314
// module chunks = 0